import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.blue.light25,
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
  headline: {
    textAlign: 'center',
    color: theme.palette.secondary.light,
    marginBottom: theme.spacing(5),
  },
  subtitle: {
    marginBottom: theme.spacing(5),
  },
  categoryTagsRow: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    marginBottom: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  categoryTags: {
    ...theme.typography.formTags,
    height: '45px',
    textAlign: 'center',
    borderRadius: '8px',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    transition: '250ms',
    backgroundColor: 'white',
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    '&:focus': {
      outline: '2px solid black',
    },
    [theme.breakpoints.down('xs')]: {
      ...theme.typography.formLabel,
      flexShrink: '0',
      fontSize: '12px',
      width: '80%',
    },
    '&:hover, &:active': {
      textDecoration: 'none',
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.offwhite.main,
    },
  },
  active: {
    backgroundColor: theme.palette.blue.main,
    color: theme.palette.offwhite.main,
  },
  divider: {
    width: '100%',
    opacity: '0.5',
    height: '1px',
    backgroundColor: theme.palette.grey.light,
  },
  sliderContainer: {
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(4),
    },
  },
  slider: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(4),
  },
  noResultsTitle: {
    color: theme.palette.secondary.light,
  },
  noResultsContainer: {
    height: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      height: '250px',
    },
  },
  noResultsBody: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  loadingContainer: {
    height: '400px',
  },
}))

export default useStyles
